module.exports = __webpack_public_path__ + "img/hunezarat.d1a554a.svg";